'use strict';

const selectors = {
    form: '.js-article-search',
    input: '.js-article-search-input',
    suggestions: '.js-article-search-suggestions',
    option: '.js-article-search-option',
    sortSelect: '.js-article-search-sort-select'
};

const ACTIVE_CLASS = 'active';
const DEBOUNCE_DELAY = 250;

/**
 * Hides the suggestion list of a search form
 * @param {jQuery} $form - article search form
 */
function closeSuggestions($form) {
    $form.find(selectors.suggestions).prop('hidden', true).empty();
    $form.find(selectors.input).attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
}

/**
 * Builds the URL of the full search for the text typed in the form
 * @param {jQuery} $form - article search form
 * @returns {string} URL of the search results page
 */
function getFullSearchUrl($form) {
    const action = $form.attr('action');
    return action + (action.indexOf('?') === -1 ? '?' : '&') + $form.serialize();
}

/**
 * Builds one suggestion option, its title already escaped by the server.
 * @param {Object} suggestion - suggested article (url, titleHtml, category)
 * @param {number} index - position in the list
 * @param {jQuery} $list - suggestion list holding the category labels
 * @returns {jQuery} option element
 */
function buildOption(suggestion, index, $list) {
    const $option = $('<a>', {
        class: 'article-search__option js-article-search-option',
        id: 'article-search-option-' + index,
        href: suggestion.url,
        role: 'option'
    });
    $('<span>', { class: 'article-search__option-title' }).html(suggestion.titleHtml).appendTo($option);
    $('<span>', { class: 'article-search__option-category', text: $list.data('label-' + suggestion.category) }).appendTo($option);
    return $option;
}

/**
 * Displays the suggested articles followed by a link to the full search
 * @param {jQuery} $form - article search form
 * @param {string} query - text the suggestions were requested for
 * @param {Array} suggestions - suggested articles
 */
function renderSuggestions($form, query, suggestions) {
    const $list = $form.find(selectors.suggestions);
    $list.empty();

    suggestions.forEach(function (suggestion, index) {
        $list.append(buildOption(suggestion, index, $list));
    });
    $('<a>', {
        class: 'article-search__option article-search__all js-article-search-option',
        id: 'article-search-option-all',
        href: getFullSearchUrl($form),
        role: 'option',
        text: $list.data('all-label').replace('{0}', query)
    }).appendTo($list);

    $list.prop('hidden', false);
    $form.find(selectors.input).attr('aria-expanded', 'true');
}

/**
 * Requests suggestions for the typed text, ignoring answers that arrive after it changed
 * @param {jQuery} $input - search field
 */
function requestSuggestions($input) {
    const $form = $input.closest(selectors.form);
    const query = $input.val().trim();

    if (query.length < $input.data('min-length')) {
        closeSuggestions($form);
        return;
    }
    $.ajax({
        url: $input.data('suggest-url'),
        method: 'GET',
        data: { q: query },
        dataType: 'json'
    }).done(function (data) {
        if ($input.val().trim() === query) {
            renderSuggestions($form, query, data.suggestions || []);
        }
    });
}

/**
 * Moves the keyboard highlight across the suggestion options
 * @param {jQuery} $input - search field
 * @param {number} step - 1 to go down, -1 to go up
 */
function moveHighlight($input, step) {
    const $options = $input.closest(selectors.form).find(selectors.option);
    if (!$options.length) {
        return;
    }
    const current = $options.index($options.filter('.' + ACTIVE_CLASS));
    const start = current === -1 && step < 0 ? 0 : current;
    const next = (start + step + $options.length) % $options.length;

    $options.removeClass(ACTIVE_CLASS);
    $input.attr('aria-activedescendant', $options.eq(next).addClass(ACTIVE_CLASS).attr('id'));
}

/**
 * Handles the keyboard navigation inside the suggestion list
 * @param {Event} e - keydown event
 */
function onKeydown(e) {
    const $input = $(e.currentTarget);
    const $form = $input.closest(selectors.form);

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        moveHighlight($input, e.key === 'ArrowDown' ? 1 : -1);
    } else if (e.key === 'Escape') {
        closeSuggestions($form);
    } else if (e.key === 'Enter') {
        const $active = $form.find(selectors.option + '.' + ACTIVE_CLASS);
        if ($active.length) {
            e.preventDefault();
            window.location.href = $active.attr('href');
        }
    }
}

module.exports = {
    init: function () {
        $(document).on('input', selectors.input, function (e) {
            const $input = $(e.currentTarget);
            clearTimeout($input.data('suggestTimer'));
            $input.data('suggestTimer', setTimeout(function () {
                requestSuggestions($input);
            }, DEBOUNCE_DELAY));
        });

        $(document).on('keydown', selectors.input, onKeydown);

        $(document).on('click', function (e) {
            const $openLists = $(selectors.suggestions + ':not([hidden])');
            if ($openLists.length && !$(e.target).closest(selectors.form).length) {
                closeSuggestions($openLists.closest(selectors.form));
            }
        });

        $(document).on('change', selectors.sortSelect, function (e) {
            $(e.currentTarget).closest('form').trigger('submit');
        });
    }
};
